import React, { createContext, useContext, useMemo, useState } from "react";

const GoogleMapContext = createContext();
const GoogleMapProvider = ({ children }) => {
  const [mapInstance, setMapInstance] = useState(null);
  const value = useMemo(() => {
    return [mapInstance, setMapInstance];
  }, [mapInstance, setMapInstance]);

  return (
    <GoogleMapContext.Provider value={value}>
      {children}
    </GoogleMapContext.Provider>
  );
};
export { GoogleMapProvider };

const useGoogleMap = () => useContext(GoogleMapContext);
export default useGoogleMap;
